import React, { useState, useCallback } from "react"
import "./TimeBar.scss"
import Draggable from "react-draggable"

const TimeSelector = () => {
  const [selectedTime, setSelectedTime] = useState("00:00")

  const handleDrag = (e: any, data: any) => {
    // Assuming the width of the container is set to reflect 24 hours
    // Adjust '400' to the actual width of your time selector in pixels
    const hours = Math.floor(data.x / (400 / 24))
    const minutes = data.x % (400 / 24) >= 400 / 48 ? 30 : 0
    const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`
    setSelectedTime(formattedTime)
  }

  return (
    <div className="time-selector">
      <Draggable axis="x" bounds="parent" onDrag={handleDrag}>
        <div className="handle"></div>
      </Draggable>
      <div>Selected Time: {selectedTime}</div>
    </div>
  )
}

export default TimeSelector
